import Vue from "vue"
import Vuex from "vuex"

import user from "./modules/user"
import lesson from "./modules/lesson"

import * as getters from "./main/getters"
import * as mutations from "./main/mutations"
import * as actions from "./main/actions"


Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        auth: "",
        token: localStorage.getItem("token") || ""
    },
    getters,
    mutations,
    actions,
    modules: {
        user,
        lesson
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js